import { Route, Routes, useNavigate, useParams } from "react-router-dom";
import { useEffect } from "react";
import { useQuery } from "react-query";

import { getCourse } from "../../../services/wp.course.query";
import { useAuth } from "../../../services/wp.auth.service";
import { useNotifications } from "../../../components/NotificationsContext";

import Loader from "../../../components/Loader";
import MyAccountMyCourse from "./MyAccountMyCourse";
import MyAccountMyCourseJoin from "./MyAccountMyCourseJoin";

const MyCourseRoutes = () => {
	const { user } = useAuth();
	const params = useParams();
	const navigate = useNavigate();
	const { addNotification } = useNotifications();
	const {
		data: course,
		isLoading
	} = getCourse(useQuery, params.courseId);

	useEffect(() => {
		if (course?.id && !user.registrations[course.id]) {
			addNotification({
				className: "bg-danger text-white",
				message: "You are not registered for this class.",
				type: "danger"
			});
			navigate("/account/classes");
		}
	}, [course]);

	return isLoading
		? <Loader height="100%" width="100%" />
		: (
			<Routes>
				<Route element={<MyAccountMyCourseJoin course={course} registration={user?.registrations[params.courseId]} />} path="/join" />
				<Route element={<MyAccountMyCourse />} path="/*" />
			</Routes>
		);
};

export default MyCourseRoutes;
